import {
  ALL,
  DISABLE_PAGE_LIMIT,
  NullOperatorValues,
  QueryFilterOperators,
} from 'types/api';
import { HandlingRequestType, StockLocationType } from 'types/inventory';
import { ServerSideQueryParams } from 'hooks/useServerSideQuery';
import {
  HandlingRequestSchema,
  HandlingRequestSchemaLite,
} from 'types/clientV2/stock';
import { MoveWarningType } from 'views/warehouse/MoveWarningContext/types';

export const VALID_MOVE_LOCATION_TYPES = [StockLocationType.BIN_SECTION];

export const ReasonTitles = {
  [MoveWarningType.CUSTOMER_MISMATCH]: 'Customer Mismatch',
  [MoveWarningType.ASSIGNMENT_MISMATCH]: 'Assignment Mismatch',
  [MoveWarningType.UNASSIGNED_BIN]: 'Unassigned Bin',
} as const;

export const handlingRequestQuery = (
  stockLotId: string
): ServerSideQueryParams<HandlingRequestSchema, HandlingRequestSchemaLite> => ({
  pageSize: DISABLE_PAGE_LIMIT,
  schema: [ALL],
  excludes: [
    {
      field: 'requestType',
      operator: QueryFilterOperators.isAnyOf,
      value: [HandlingRequestType.CONSUME],
    },
  ],
  filters: [
    {
      field: 'stockLot',
      operator: QueryFilterOperators['='],
      value: stockLotId,
    },
    {
      field: 'pickedAt',
      operator: QueryFilterOperators.isEmpty,
      value: NullOperatorValues.isEmpty,
    },
    {
      // eslint-disable-next-line no-restricted-syntax
      field: 'cancelledAt',
      operator: QueryFilterOperators.isEmpty,
      value: NullOperatorValues.isEmpty,
    },
    {
      field: 'approvedAt',
      operator: QueryFilterOperators.isNotEmpty,
      value: NullOperatorValues.isNotEmpty,
    },
  ],
});
